import React, { useEffect, useState } from 'react';

import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';


function Index({setShowDrinks}) {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
   
    



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999}}>
        <LayoutContent showBack={true} setShowListProduct={()=>setShowDrinks(false)}>
            <div>
                    <img src={require('./assets/lunch2.png')} style={{
                        objectFit: 'contain',
                        width: 730,
                }}/>
            </div>


            
        </LayoutContent>
        </div>
    );
}

export default Index;